// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@riseart/common';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';
import { ArtistActionSection } from 'shared_components/artist/sections/action/Section';
import { EnquireOverlay } from 'shared_components/enquire/Overlay';
import { EnquireCommissionForm } from 'shared_components/forms/enquire/Commission';

type Props = {
  data: Object,
  background: string | null,
  title: string | Node,
  subtitle: string | Node,
};

/**
 * ArtistCommissionSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export function ArtistCommissionSection({ data, background, title, subtitle }: Props): Node {
  return (
    <ArtistActionSection title={title} subtitle={subtitle} background={background}>
      <FormattedMessage id="common.learnMore">
        {(text: string) => (
          <Button
            type="secondary"
            isAnchor
            external
            href={LocalizedConfig.get('externalUrls.artCommissionsPage')}
            target="_blank"
            width="fixed"
            title={text}
          >
            {text}
          </Button>
        )}
      </FormattedMessage>
      <EnquireOverlay
        title={
          <FormattedMessage id="forms.enquireArtistCommission.title">
            {(label: string) => label}
          </FormattedMessage>
        }
        component={({ onClose }) => <EnquireCommissionForm onClose={onClose} artist={data} />}
      >
        <Button type="primary" width="fixed">
          <FormattedMessage id="common.enquire" />
        </Button>
      </EnquireOverlay>
    </ArtistActionSection>
  );
}
